import { useAccountContext } from '@gonfalon/app-context/useAccountContext';
import type { Experiment } from '@gonfalon/experiments/types';
import { isReader } from '@gonfalon/members/isReader';
import type { Member } from '@gonfalon/members/types';
import { genericCheckAccess } from '@gonfalon/permissions/access';

// Whether the member can perform experiment CRUD actions. With an experiment, uses its `_access`
// so custom roles are respected; without one, falls back to the coarse reader check.
export function useHasEntityCrudOperationsAccess(experiment?: Experiment): { isAllowed: boolean } {
  const { profile } = useAccountContext();

  const isAllowed = experiment ? canUpdateExperiment(profile, experiment) : !isReader(profile);

  return { isAllowed };
}

export function canUpdateExperiment(profile: Member, experiment: Experiment) {
  return genericCheckAccess('experiment', profile, 'updateExperiment', experiment._access).isAllowed;
}
